import { GameIntroView, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { IEvent } from "@quest/adapter-interface";
import { detectDeviceEnvironmentConstants, ingenuity, Container, killDelayedCall, ITween, Linear, delayedLoopCall, dispatcher } from "@quest/base-core";
import { gameConstants } from "../Constants/gameConstants";

export class GameIntroViewGame extends GameIntroView {

  protected gameIntroCharacterContainer: Container;
  protected gameIntroLogo: Container;
  protected elementMainContainer: Container;
  protected tweenPotionArray: Container[] = [];
  protected gameFeatureLabelContainer1: Container;
  protected gameFeatureLabelContainer2: Container;

  constructor(json: any) {
    super(json);
    this.visible = false;
    this.initializeElements();
  }

  // Add to initialize elements
  protected initializeElements(): void {
    this.gameIntroCharacterContainer = this.getContainerByID("gameIntroCharacterContainer");
    this.gameIntroLogo = this.getContainerByID("goldenSpinLogoContainer");
    this.elementMainContainer = this.getContainerByID("elementMainContainer");
    this.gameFeatureLabelContainer1 = this.getContainerByID("gameFeatureLabelContainer1") as Container;
    this.gameFeatureLabelContainer2 = this.getContainerByID("gameFeatureLabelContainer2") as Container;
  }
  /**
   * Add to show view
   */
  public showView(): void {
    this.visible = true;
    this.getButtonById(SlotConstantsBehavior.GAME_INTRO_CONTINUE_BTN).visible = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.GAME_INTRO_BG_SHOW);
  }
  /**
   * Add to hide view
   */
  public hideView(): void {
    this.visible = false;
  }
  /**
   * Method overrided to handle resizing
   */
  protected resize(evt?: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT ) {
      this.resetView();
      this.showPortraitSlides();
      this.allignPortraitCharacter();
      this.setGameIntroLogoValues(ingenuity.deviceEnv.getPortraitScale());
      this.allignPortraitSlides(ingenuity.deviceEnv.getPortraitMaxScale());
    } else {
      this.resetValues();
      this.pivot.set(SlotConstantsBehavior.BACKGROUND_WIDTH * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
      this.scale.set(Math.min((innerHeight / ingenuity.configData.height), (innerWidth / ingenuity.configData.width)));
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
      if (ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + SlotConstantsBehavior.VIEW_SLIDE_DESKTOP;
      } else {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + SlotConstantsBehavior.VIEW_SLIDE_MOBILE;
      }
    }
  }
  // Add to set game intro container values
  protected allignPortraitCharacter(): void {
    const scale = Math.min((innerHeight / this.getImageById("gameIntroPortrait").height), (innerWidth / this.getImageById("gameIntroPortrait").width))
    this.gameIntroCharacterContainer && this.gameIntroCharacterContainer.scale.set(scale);
    this.gameIntroCharacterContainer && this.gameIntroCharacterContainer.pivot.set(ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER, 0);
    this.gameIntroCharacterContainer && (this.gameIntroCharacterContainer.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER);
    this.gameIntroCharacterContainer && (this.gameIntroCharacterContainer.y = 0);
  }
  // to allign portrait slides
  protected allignPortraitSlides(scale: number): void {
    this.elementMainContainer && this.elementMainContainer.scale.set(scale);
    this.elementMainContainer && this.elementMainContainer.pivot.set(ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER);
    this.elementMainContainer && (this.elementMainContainer.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER);
    this.elementMainContainer && (this.elementMainContainer.y = innerHeight);
  }

  // Add to set game intro logo values
  protected setGameIntroLogoValues(scale: number): void {
    const logoExtraScaling: number = gameConstants.LOGO_EXTRA_SCALE;
    this.gameIntroLogo && this.gameIntroLogo.scale.set(scale * logoExtraScaling);
    this.gameIntroLogo && (this.gameIntroLogo.y = innerHeight - gameConstants.EXTRA_SPACE);
    this.gameIntroLogo && this.gameIntroLogo.pivot.set(0, this.gameIntroLogo.json.regY);
  }
  // Add to reset game intro view values
  protected resetView(): void {
    this.scale.set(1);
    this.pivot.set(0);
    this.position.set(0);
  }

  // Add to reset game intro main container values
  protected resetValues(): void {
    this.gameIntroLogo?.scale.set(1);
    this.gameIntroLogo?.pivot.set(0);
    this.gameIntroCharacterContainer?.scale.set(1);
    this.gameIntroCharacterContainer?.pivot.set(0);
    this.gameIntroCharacterContainer?.position.set(0);
    this.elementMainContainer?.scale.set(1);
    this.elementMainContainer?.pivot.set(0);
    this.elementMainContainer?.position.set(0);
    this.gameFeatureLabelContainer1 && (this.gameFeatureLabelContainer1.alpha = 1);
    this.gameFeatureLabelContainer2 && (this.gameFeatureLabelContainer2.alpha = 1);
    killDelayedCall("delayToNextSlide");
    ingenuity.currentGame.tweens.removeFrom(this);
  }
  /**
   * function is responsible to show slides in portrait one by one
   */
  protected async showPortraitSlides(): Promise<void> {
    const maxPotionContainer: number = 1;
    let postIntroCounter: number = 0;
    killDelayedCall("delayToNextSlide");
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT && this.gameFeatureLabelContainer1) {
      this.tweenPotionArray.push(this.gameFeatureLabelContainer1, this.gameFeatureLabelContainer2);
      delayedLoopCall("delayToNextSlide", 3500, async () => {
        await this.fadeOutTween(this.tweenPotionArray[postIntroCounter]);
        postIntroCounter = (postIntroCounter + 1) % (maxPotionContainer + 1);
        this.tweenPotionArray[postIntroCounter].visible = true;
        await this.fadeInTween(this.tweenPotionArray[postIntroCounter]);
      });
    }
  }
  /**
   * to show container with fade out
   */
  protected fadeOutTween(container: Container): Promise<void> {
    return new Promise((resolve) => {
      const tween: ITween = ingenuity.currentGame.add.tween(container);
      tween.to({ alpha: 0 }, 600, Linear.None, true);
      tween.onComplete.addOnce(resolve);
    });
  }
  /**
   * to show container with fade in
   */
  protected fadeInTween(container: Container): Promise<void> {
    return new Promise((resolve) => {
      container.alpha = 0;
      const tween: ITween = ingenuity.currentGame.add.tween(container);
      tween.to({ alpha: 1 }, 600, Linear.None, true); 
      tween.onComplete.addOnce(resolve);
    });
  }
}
